import { render, staticRenderFns } from "./AssetProjectsList.vue?vue&type=template&id=40924676&"
import script from "./AssetProjectsList.vue?vue&type=script&lang=js&"
export * from "./AssetProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports